/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingGovernanceRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getGovernanceStatusRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingGovernanceRpc',
  rpcName: 'getGovernanceStatus',
  auth: 'app',
  fingerprint: 'bqNids6B10FJbrUXPaE61pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};